import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { DefaultTheme } from "styled-components/native";

export type PopupProps = {
  title?: string;
  buttons: {
    type: ButtonType;
    category?: ButtonCategory;
    isLoadingButton?: boolean;
    title: string;
    onPressAction: () => void;
    loading?: boolean;
    disabled?: boolean;
  }[];
  type?: String;
  HtmlSource?: any;
  styleKey: string;
  colorKey?: keyof DefaultTheme;
  isLoading?: boolean;
  hasChildren?: boolean;
  children?: React.ReactNode;
  isFromSavedSearch?: boolean;
  maxWidth?: string;
  onClose?: () => void;
  showCloseButton?: boolean;
  applyMaxHeight?: boolean;
};

export type IconFrameProps = {
  backgroundColor: string;
};

export type PopupHeaderProps = {
  backgroundColor: string;
};

export enum messageType {
  Error = "Error",
  Success = "Success",
  Warning = "Warning",
  Generic = "Generic",
}
